import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=5cdd0880&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=5cdd0880&lang=scss&scoped=true&"
import style1 from "./Main.vue?vue&type=style&index=1&id=5cdd0880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd0880",
  null
  
)

export default component.exports